import type { CustomerToolKey } from "@ishvaram/domain-data/customer-tools";

export type MatchingSurface = "tool" | "gun-milan" | "share";

/** Surfaces that own a completable matching form ("share" is read-only). */
export type MatchingCompletionSurface = Exclude<MatchingSurface, "share">;

export type MatchingInputMode = "birth_details" | "naam_akshar";

export function matchingSourcePath(surface: MatchingSurface, language: "en" | "hi"): string {
  if (surface === "gun-milan") return language === "hi" ? "/hi/gun-milan" : "/gun-milan";
  return language === "hi" ? "/hi/kundli-matching" : "/kundli-matching";
}

/**
 * Each completion surface keeps its own governed tool series — /gun-milan/'s
 * birth mode already reports `gun-milan`, so its naam mode must too, or one
 * page's completions split across two tool ids (rule 47 #7).
 */
export function matchingToolKey(surface: MatchingCompletionSurface): CustomerToolKey {
  return surface === "gun-milan" ? "gun-milan" : "kundli-matching";
}

/**
 * Canonical dimensions for the two input modes that complete the same matching
 * task. The surface is required — a shared mode component rendered by several
 * routes must take its attribution from the route owner, never default to one
 * of them (rule 47 #7).
 */
export function matchingCompletionContext(
  surface: MatchingCompletionSurface,
  language: "en" | "hi",
  inputMode: MatchingInputMode
) {
  return {
    language,
    source_path: matchingSourcePath(surface, language),
    input_mode: inputMode,
  } as const;
}
